/* SEERAT v5.4.0 — Facticied */
(function () {
  'use strict';

  /* ---------------- Delivery estimate ---------------- */

  function parseOffset(tz) {
    var m = /^([+-])(\d{2}):(\d{2})$/.exec(tz || '');
    if (!m) return 0;
    var mins = parseInt(m[2], 10) * 60 + parseInt(m[3], 10);
    return m[1] === '-' ? -mins : mins;
  }

  function Delivery(el) {
    this.el = el;
    this.processing = parseInt(el.getAttribute('data-processing'), 10) || 0;
    this.min = parseInt(el.getAttribute('data-min'), 10) || 1;
    this.max = parseInt(el.getAttribute('data-max'), 10) || this.min;
    if (this.max < this.min) this.max = this.min;
    this.cutoff = parseInt(el.getAttribute('data-cutoff'), 10);
    if (isNaN(this.cutoff)) this.cutoff = 14;
    this.offset = parseOffset(el.getAttribute('data-tz'));
    this.skipWeekends = el.getAttribute('data-weekends') === 'true';
    this.countdownTpl = el.getAttribute('data-countdown-text') || '';
    this.estimateTpl = el.getAttribute('data-estimate-text') || '';
    this.todayWord = el.getAttribute('data-today') || 'today';
    this.cdRow = el.querySelector('[data-delivery-countdown]');
    this.cdText = el.querySelector('[data-delivery-countdown-text]');
    this.esRow = el.querySelector('[data-delivery-estimate]');
    this.esText = el.querySelector('[data-delivery-estimate-text]');
    var lang = document.documentElement.lang || 'en';
    try {
      this.fmt = new Intl.DateTimeFormat(lang, { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' });
    } catch (e) {
      this.fmt = new Intl.DateTimeFormat('en', { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' });
    }
    this.render();
    var self = this;
    setInterval(function () { self.render(); }, 30000);
  }

  // Dates are shifted into store time and read with UTC getters
  Delivery.prototype.isBusiness = function (d) {
    if (!this.skipWeekends) return true;
    var day = d.getUTCDay();
    return day !== 0 && day !== 6;
  };

  Delivery.prototype.addDays = function (d, n) {
    var out = new Date(d.getTime());
    var added = 0;
    while (added < n) {
      out.setUTCDate(out.getUTCDate() + 1);
      if (this.isBusiness(out)) added++;
    }
    return out;
  };

  Delivery.prototype.compute = function (nowMs) {
    var storeNow = new Date(nowMs + this.offset * 60000);
    var start = new Date(Date.UTC(storeNow.getUTCFullYear(), storeNow.getUTCMonth(), storeNow.getUTCDate()));
    var sameDay = this.isBusiness(start) && storeNow.getUTCHours() < this.cutoff;

    if (!sameDay) {
      do { start.setUTCDate(start.getUTCDate() + 1); } while (!this.isBusiness(start));
    }

    var dispatch = this.addDays(start, this.processing);
    var cutoffMoment = new Date(start.getTime() + this.cutoff * 3600000);

    return {
      sameDay: sameDay,
      remaining: cutoffMoment.getTime() - storeNow.getTime(),
      dispatchToday: sameDay && this.processing === 0,
      dispatch: dispatch,
      from: this.addDays(dispatch, this.min),
      to: this.addDays(dispatch, this.max)
    };
  };

  Delivery.prototype.duration = function (ms) {
    var mins = Math.max(1, Math.floor(ms / 60000));
    var h = Math.floor(mins / 60);
    var m = mins % 60;
    return h > 0 ? h + 'h ' + m + 'm' : m + 'm';
  };

  Delivery.prototype.render = function () {
    var r = this.compute(Date.now());
    var dispatchLabel = r.dispatchToday ? this.todayWord : this.fmt.format(r.dispatch);

    if (this.cdRow && this.countdownTpl && r.sameDay) {
      this.cdText.textContent = this.countdownTpl
        .replace('[time]', this.duration(r.remaining))
        .replace('[dispatch]', dispatchLabel);
      this.cdRow.hidden = false;
    } else if (this.cdRow) {
      this.cdRow.hidden = true;
    }

    if (this.esRow && this.estimateTpl) {
      this.esText.textContent = this.estimateTpl
        .replace('[start]', this.fmt.format(r.from))
        .replace('[end]', this.fmt.format(r.to));
      this.esRow.hidden = false;
    }
  };

  /* ---------------- Sticky add to cart ---------------- */

  function Sticky(el) {
    var id = el.getAttribute('data-section-id');
    var main = document.getElementById('ProductSubmitButton-' + id);
    if (!main) { el.parentNode && el.parentNode.removeChild(el); return; }

    // Remove any copy left in body from a previous editor render, then escape transformed parents
    var old = document.querySelectorAll('body > [data-seerat-sticky][data-section-id="' + id + '"]');
    Array.prototype.forEach.call(old, function (n) { if (n !== el) n.parentNode.removeChild(n); });
    document.body.appendChild(el);

    var btn = el.querySelector('[data-sticky-submit]');
    var label = el.querySelector('[data-sticky-label]');
    var watchTarget = main.closest('product-form') || main;

    function isDisabled() {
      return main.hasAttribute('disabled') || main.getAttribute('aria-disabled') === 'true';
    }

    function sync() {
      var disabled = isDisabled();
      btn.disabled = disabled;
      btn.classList.toggle('loading', main.classList.contains('loading'));
      var mainText = main.querySelector('span');
      label.textContent = disabled && mainText ? mainText.textContent.trim() : btn.getAttribute('data-label');
    }

    btn.addEventListener('click', function () {
      if (isDisabled()) return;
      main.click();
    });

    if ('MutationObserver' in window) {
      new MutationObserver(sync).observe(main, { attributes: true, childList: true, subtree: true, characterData: true });
    }
    sync();

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        el.classList.toggle('is-visible', past);
        el.setAttribute('aria-hidden', past ? 'false' : 'true');
        btn.tabIndex = past ? 0 : -1;
      }).observe(watchTarget);
    }
  }


  /* ---------------- Size guide dialog ---------------- */

  function SizeGuide(root) {
    var openBtn = root.querySelector('[data-sg-open]');
    var dialog = root.querySelector('dialog');
    if (!openBtn || !dialog || typeof dialog.showModal !== 'function') return;

    openBtn.addEventListener('click', function () {
      dialog.showModal();
      document.documentElement.classList.add('seerat-lock');
    });

    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('seerat-lock');
      openBtn.focus();
    });

    Array.prototype.forEach.call(dialog.querySelectorAll('[data-sg-close]'), function (b) {
      b.addEventListener('click', function () { dialog.close(); });
    });

    // Click on the dimmed backdrop closes it
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });

    var unitBtns = dialog.querySelectorAll('[data-sg-unit]');
    Array.prototype.forEach.call(unitBtns, function (btn) {
      btn.addEventListener('click', function () {
        var unit = btn.getAttribute('data-sg-unit');
        Array.prototype.forEach.call(unitBtns, function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        Array.prototype.forEach.call(dialog.querySelectorAll('[data-cm]'), function (cell) {
          cell.textContent = cell.getAttribute(unit === 'in' ? 'data-in' : 'data-cm');
        });
      });
    });
  }


  /* ---------------- Save percentage ---------------- */

  function Save(el) {
    this.el = el;
    this.render();
    var self = this;
    el.addEventListener('seerat:save-update', function () { self.render(); });
  }

  Save.prototype.render = function () {
    var el = this.el;
    var price = parseInt(el.getAttribute('data-price'), 10) || 0;
    var compare = parseInt(el.getAttribute('data-compare'), 10) || 0;
    var min = parseInt(el.getAttribute('data-min'), 10) || 1;
    var pct = compare > price && compare > 0 ? Math.round(((compare - price) / compare) * 100) : 0;
    var show = pct >= min;
    var text = (el.getAttribute('data-text') || 'Save [percent]%').replace('[percent]', pct);

    var pill = el.querySelector('[data-save-pill]');
    if (pill) {
      pill.textContent = text;
      pill.hidden = !(show && el.getAttribute('data-on-price') === 'true');
    }
    el.classList.toggle('is-empty', !show);

    var gallery = document.getElementById(el.getAttribute('data-gallery'));
    if (gallery) {
      var badge = gallery.querySelector('.seerat-save-badge');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'seerat-save-badge';
        badge.setAttribute('aria-hidden', 'true');
        gallery.appendChild(badge);
      }
      badge.textContent = text;
      badge.className = 'seerat-save-badge seerat-save-badge--' + (el.className.match(/seerat-save--(filled|outline|dark)/) || [0, 'filled'])[1];
      badge.hidden = !(show && el.getAttribute('data-on-image') === 'true');
    }
  };

  /* ---------------- Variant change sync ---------------- */

  var subscribed = false;
  function listenForVariants() {
    if (subscribed) return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribed = true;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (!event || !event.data || !event.data.html) return;
      var id = event.data.sectionId;
      var html = event.data.html;
      ['SeeratStock-', 'SeeratStickyPrice-', 'SeeratStickyVariant-', 'SeeratSaveMedia-'].forEach(function (prefix) {
        var src = html.getElementById(prefix + id);
        var dst = document.getElementById(prefix + id);
        if (src && dst) {
          dst.innerHTML = src.innerHTML;
          dst.className = src.className;
        }
      });
    });
  }

  /* ---------------- Init ---------------- */

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-seerat-delivery]'), function (el) {
      if (el.dataset.ready === 'true') return;
      el.dataset.ready = 'true';
      new Delivery(el);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-seerat-sticky]'), function (el) {
      if (el.dataset.ready === 'true') return;
      el.dataset.ready = 'true';
      new Sticky(el);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-seerat-save]'), function (el) {
      if (el.dataset.ready === 'true') return;
      el.dataset.ready = 'true';
      new Save(el);
    });
    Array.prototype.forEach.call(document.querySelectorAll('.seerat-sg'), function (el) {
      if (el.dataset.ready === 'true') return;
      el.dataset.ready = 'true';
      new SizeGuide(el);
    });
    listenForVariants();
    pairQuantityWithCart();
  }

  /* Quantity belongs beside Add to cart, not stacked above it on a line of its
     own. Shopify gives them to us as two separate blocks, so the stepper is
     moved into the button row once and the row is laid out as a grid.

     Safe to move: on a variant change Dawn only rewrites the innards of the
     price, SKU and inventory nodes and toggles the submit button. It never
     replaces this row, so the stepper stays where it was put. If this script
     never runs, the two simply stay stacked, which still works. */
  function pairQuantityWithCart() {
    Array.prototype.forEach.call(document.querySelectorAll('.seerat-pdp'), function (root) {
      var qty = root.querySelector('.product-form__quantity');
      var row = root.querySelector('.product-form__buttons');
      if (!qty || !row || qty.dataset.seeratPaired === 'true') return;
      if (row.contains(qty)) return;
      qty.dataset.seeratPaired = 'true';
      row.insertBefore(qty, row.firstChild);
      row.classList.add('seerat-buyrow');
    });
  }

  window.SeeratDelivery = Delivery;
  window.SeeratSave = Save;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
